import { TrainingOfferModality } from "@root/utils/enums/offer";
import type { FieldErrors } from "react-hook-form";
import type {
  ITrainingSharedFormFieldNames,
  TTrainingSharedFormFieldValues,
  TTrainingSharedFormValues,
  TrainingOfferValidation,
  TrainingOfferWage,
} from "../types";

export interface ITrainingSharedFormSectionProps<TForm extends TTrainingSharedFormFieldValues> {
  fields: ITrainingSharedFormFieldNames<TForm>;
}

export const VALIDATIONS: { value: TrainingOfferValidation; label: string }[] = [
  {
    value: TrainingOfferModality.CERTIFYING,
    label: "Certifiante",
  },
  {
    value: TrainingOfferModality.QUALIFYING,
    label: "Qualifiante",
  },
];

export const WAGES: { value: TrainingOfferWage; label: string }[] = [
  {
    value: TrainingOfferModality.PAID,
    label: "Rémunérée",
  },
  {
    value: TrainingOfferModality.UNPAID,
    label: "Non rémunérée",
  },
];

const isObjectRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null;
};

export const getAddressHelperText = (error: unknown) => {
  if (!isObjectRecord(error)) {
    return undefined;
  }

  if (typeof error.message === "string") {
    return error.message;
  }

  if (isObjectRecord(error.loc) && typeof error.loc.message === "string") {
    return error.loc.message;
  }

  return undefined;
};

export const getContactErrors = <TForm extends TTrainingSharedFormFieldValues>(
  errors: FieldErrors<TForm>
): FieldErrors<{ contact: TTrainingSharedFormValues["contact"] }> => ({
  contact: errors.contact,
});
